import Vue from "vue";
import i18n from "@/i18n";
import Router from "vue-router";
import store from "./store.js";
import { isRestrictedEventTypeUserType } from "@/constants/backofficeUserTypes.js";

import Home from "@/views/Home";
import Competition from "@/views/Competition";
import Login from "@/views/Login";
import ChangePassword from "@/views/ChangePassword";

import ListView from "@/views/ListView";
import FormView from "@/views/FormView";
import ReportView from "@/views/ReportView";

//Profiles
import ClubProfile from "@/views/profiles/Club";
import TeamProfile from "@/views/profiles/Team";
import PersonProfile from "@/views/profiles/Person";
import UserProfile from "@/views/profiles/User";
import VolunteerProfile from "@/views/profiles/Volunteer";
import HotelProfile from "@/views/profiles/Hotel";
import TravelProfile from "@/views/profiles/Travel";
import FacilityProfile from "@/views/profiles/Facility";
import FinancesProfile from "@/views/profiles/Finances";
import DocumentationProfile from "@/views/profiles/Documentation";
import ParticipantProfile from "@/views/profiles/Participant";
//Forms
import PersonForm from "@/views/forms/Person";
import TravelForm from "@/views/forms/Travel";
import FacilityForm from "@/views/forms/Facility";
import MatchForm from "@/views/forms/Match";
import SanctionsForm from "@/views/forms/Sanction";
import Settings from "@/views/forms/Settings";
//Finances
// import FinancesPayments from '@/views/finances/Payments'
// import FinancesPrices from '@/views/finances/Prices'
// import FinancesDiscounts from '@/views/finances/Discounts'
//Competition
import CompetitionStats from "@/views/competition/Stats";

let notifier = new Vue();

//Event
import EventHome from "@/views/Event";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/login",
      name: "login",
      component: Login,
      meta: {
        layout: "login"
      },
      props: {
        page: "login"
      }
    },
    {
      path: "/changepassword/:id/:limit",
      name: "changepassword",
      component: ChangePassword,
      meta: {
        layout: "login"
      },
      props: {
        page: "changepassword"
      }
    },
    {
      path: "/",
      name: "home",
      component: Home,
      beforeEnter: requireAuth,
      props: {
        page: "home"
      }
    },
    {
      path: "/club",
      name: "clubs",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "clubs"
      }
    },
    {
      path: "/club/add",
      name: "clubs_add",
      component: FormView,
      beforeEnter: requireAuth,
      props: {
        page: "clubs_add",
        action: "add"
      }
    },
    {
      path: "/club/edit/:id",
      name: "clubs_edit",
      component: FormView,
      beforeEnter: requireAuth,
      props: {
        page: "clubs_edit",
        action: "edit"
      }
    },
    {
      path: "/club/card/:id",
      name: "clubs_card",
      component: ClubProfile,
      beforeEnter: requireAuth,
      props: {
        page: "clubs_card"
      }
    },
    {
      path: "/event",
      name: "events",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "events"
      }
    },
    {
      path: "/person",
      name: "persons_home",
      redirect: { name: "persons", params: { submenu: "competition" } },
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "persons"
      }
    },
    {
      path: "/person/add",
      name: "persons_add",
      component: PersonForm,
      beforeEnter: requireAuth,
      props: {
        page: "persons_add",
        action: "add"
      }
    },
    {
      path: "/person/:submenu",
      name: "persons",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "persons",
        submenu: "competition"
      }
    },
    {
      path: "/person/card/:id",
      name: "persons_card",
      component: PersonProfile,
      beforeEnter: requireAuth,
      props: {
        page: "persons_card"
      }
    },
    {
      path: "/person/edit/:id",
      name: "persons_edit",
      component: PersonForm,
      beforeEnter: requireAuth,
      props: {
        page: "persons_edit",
        action: "edit"
      }
    },
    {
      path: "/person/edit/:id/:type/:role_id",
      name: "persons_role_edit",
      component: FormView,
      beforeEnter: requireAuth,
      props: {
        page: "persons_role_edit",
        action: "edit"
      }
    },
    {
      path: "/event/:event",
      name: "event_home",
      component: EventHome,
      beforeEnter: requireAuth,
      props: {
        page: "event_home"
      }
    },
    {
      path: "/event/:event/club",
      name: "event_clubs",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_clubs"
      }
    },
    {
      path: "/event/:event/club/add",
      name: "event_clubs_add",
      component: FormView,
      beforeEnter: requireAuth,
      props: {
        page: "event_clubs_add",
        action: "add"
      }
    },
    {
      path: "/event/:event/club/card/:id",
      name: "event_clubs_card",
      component: ClubProfile,
      beforeEnter: requireAuth,
      props: {
        page: "event_clubs_card"
      }
    },
    {
      path: "/event/:event/club/edit/:id",
      name: "event_clubs_edit",
      component: FormView,
      beforeEnter: requireAuth,
      props: {
        page: "event_clubs_edit",
        action: "edit"
      }
    },
    {
      path: "/event/:event/person",
      name: "event_persons_home",
      redirect: "/event/:event/person/competition",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_persons"
      }
    },
    {
      path: "/event/:event/person/add",
      name: "event_persons_add",
      component: PersonForm,
      beforeEnter: requireAuth,
      props: {
        page: "event_persons_add",
        action: "add"
      }
    },
    {
      path: "/event/:event/person/:submenu",
      name: "event_persons",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_persons"
      }
    },
    {
      path: "/event/:event/person/card/:id",
      name: "event_persons_card",
      component: PersonProfile,
      beforeEnter: requireAuth,
      props: {
        page: "event_persons_card"
      }
    },
    {
      path: "/event/:event/person/edit/:id",
      name: "event_persons_edit",
      component: PersonForm,
      beforeEnter: requireAuth,
      props: {
        page: "event_persons_edit",
        action: "edit"
      }
    },
    {
      path: "/event/:event/person/edit/:id/:type/:role_id",
      name: "event_persons_role_edit",
      component: FormView,
      beforeEnter: requireAuth,
      props: {
        page: "event_persons_role_edit",
        action: "edit"
      }
    },
    {
      path: "/event/:event/team",
      name: "event_teams",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_teams"
      }
    },
    {
      path: "/event/:event/team/report",
      name: "event_teams_report",
      component: ReportView,
      beforeEnter: requireAuth,
      props: {
        page: "event_teams",
        submenu: "report"
      }
    },
    {
      path: "/event/:event/team/card/:id",
      name: "event_teams_card",
      component: TeamProfile,
      beforeEnter: requireAuth,
      props: {
        page: "event_teams_card"
      }
    },
    {
      path: "/event/:event/team/add",
      name: "event_teams_add",
      component: FormView,
      beforeEnter: requireAuth,
      props: {
        page: "event_teams_add",
        action: "add"
      }
    },
    {
      path: "/event/:event/team/edit/:id",
      name: "event_teams_edit",
      component: FormView,
      beforeEnter: requireAuth,
      props: {
        page: "event_teams_edit",
        action: "edit"
      }
    },
    {
      path: "/event/:event/settings",
      name: "event_settings",
      component: Settings,
      beforeEnter: requireAuth,
      props: {
        page: "event_settings"
      }
    },
    {
      path: "/event/:event/finances",
      name: "event_finances",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_finances"
      },
      redirect: "/event/:event/finances/payments"
    },
    {
      path: "/event/:event/finances/add",
      name: "event_finances_add",
      component: FinancesProfile,
      beforeEnter: requireAuth,
      props: {
        page: "event_finances_add",
        action: "add"
      }
    },
    {
      path: "/event/:event/finances/payments",
      name: "event_finances_payments",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_finances",
        submenu: "payments",
        filters: false
      }
    },
    {
      path: "/event/:event/finances/prices",
      name: "event_finances_prices",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_finances",
        submenu: "prices",
        filters: false
      }
    },
    {
      path: "/event/:event/finances/discounts",
      name: "event_finances_discounts",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_finances",
        submenu: "discounts",
        filters: false
      }
    },
    {
      path: "/event/:event/documentation",
      name: "event_documentation",
      component: DocumentationProfile,
      beforeEnter: requireAuth,
      props: {
        page: "event_documentation",
        action: "add"
      }
    },
    {
      path: "/event/:event/documentation/add",
      name: "event_documentation_add",
      component: FormView,
      beforeEnter: requireAuth,
      props: {
        page: "documentation_add",
        action: "add"
      }
    },
    {
      path: "/event/:event/documentation/edit/:id",
      name: "event_documentation_edit",
      component: FormView,
      beforeEnter: requireAuth,
      props: {
        page: "documentation_edit",
        action: "edit"
      }
    },
    {
      path: "/event/:event/participants",
      name: "event_participants",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_persons"
      }
    },
    {
      path: "/event/:event/participants/card/:id",
      name: "event_participants_card",
      component: ParticipantProfile,
      beforeEnter: requireAuth,
      props: {
        page: "event_persons_card"
      }
    },
    {
      path: "/volunteer",
      name: "volunteers",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "volunteers"
      }
    },
    {
      path: "/volunteer/card/:id",
      name: "volunteers_card",
      component: VolunteerProfile,
      beforeEnter: requireAuth,
      props: {
        page: "volunteers_card"
      }
    },
    {
      path: "/volunteer/edit/:id",
      name: "volunteers_edit",
      component: FormView,
      beforeEnter: requireAuth,
      props: {
        page: "volunteers_edit",
        action: "edit"
      }
    },
    {
      path: "/volunteer/add",
      name: "volunteers_add",
      component: FormView,
      beforeEnter: requireAuth,
      props: {
        page: "volunteers_add",
        action: "add"
      }
    },
    {
      path: "/event/:event/volunteer",
      name: "event_volunteers",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_volunteers"
      }
    },
    {
      path: "/event/:event/volunteer/card/:id",
      name: "event_volunteers_card",
      component: VolunteerProfile,
      beforeEnter: requireAuth,
      props: {
        page: "event_volunteers_card"
      }
    },
    {
      path: "/event/:event/volunteer/edit/:id",
      name: "event_volunteers_edit",
      component: FormView,
      beforeEnter: requireAuth,
      props: {
        page: "event_volunteers_edit",
        action: "edit"
      }
    },
    {
      path: "/event/:event/volunteer/add",
      name: "event_volunteers_add",
      component: FormView,
      beforeEnter: requireAuth,
      props: {
        page: "event_volunteers_add",
        action: "add"
      }
    },
    {
      path: "/user",
      name: "user",
      component: ListView,
      beforeEnter: requireBackofficeUserAdmin,
      props: {
        page: "user"
      }
    },
    {
      path: "/user/card/:id",
      name: "user_card",
      component: UserProfile,
      beforeEnter: requireBackofficeUserAdmin,
      props: {
        page: "user_card"
      }
    },
    {
      path: "/user/edit/:id",
      name: "user_edit",
      component: FormView,
      beforeEnter: requireBackofficeUserAdmin,
      props: {
        page: "user_edit",
        action: "edit"
      }
    },
    {
      path: "/user/add",
      name: "user_add",
      component: FormView,
      beforeEnter: requireBackofficeUserAdmin,
      props: {
        page: "user_add",
        action: "add"
      }
    },
    {
      path: "/hotel",
      name: "hotels",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "hotels"
      }
    },
    {
      path: "/hotel/card/:id",
      name: "hotels_card",
      component: HotelProfile,
      beforeEnter: requireAuth,
      props: {
        page: "hotels_card"
      }
    },
    {
      path: "/hotel/edit/:id",
      name: "hotels_edit",
      component: FormView,
      beforeEnter: requireAuth,
      props: {
        page: "hotels_edit",
        action: "edit"
      }
    },
    {
      path: "/hotel/add",
      name: "hotels_add",
      component: FormView,
      beforeEnter: requireAuth,
      props: {
        page: "hotels_add",
        action: "add"
      }
    },
    {
      path: "/event/:event/hotel",
      name: "event_hotels",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_hotels"
      }
    },
    {
      path: "/event/:event/hotel/card/:id",
      name: "event_hotels_card",
      component: HotelProfile,
      beforeEnter: requireAuth,
      props: {
        page: "event_hotels_card"
      }
    },
    {
      path: "/event/:event/hotel/edit/:id",
      name: "event_hotels_edit",
      component: FormView,
      beforeEnter: requireAuth,
      props: {
        page: "event_hotels_edit",
        action: "edit"
      }
    },
    {
      path: "/event/:event/hotel/add",
      name: "event_hotels_add",
      component: FormView,
      beforeEnter: requireAuth,
      props: {
        page: "event_hotels_add",
        action: "add"
      }
    },
    {
      path: "/facility",
      name: "facilitys",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "facilitys"
      }
    },
    {
      path: "/facility/card/:id",
      name: "facilitys_card",
      component: FacilityProfile,
      beforeEnter: requireAuth,
      props: {
        page: "facilitys_card"
      }
    },
    {
      path: "/facility/edit/:id",
      name: "facilitys_edit",
      component: FacilityForm,
      beforeEnter: requireAuth,
      props: {
        page: "facilitys_edit",
        action: "edit"
      }
    },
    {
      path: "/facility/add",
      name: "facilitys_add",
      component: FacilityForm,
      beforeEnter: requireAuth,
      props: {
        page: "facilitys_add",
        action: "add"
      }
    },
    {
      path: "/event/:event/facility",
      name: "event_facilitys",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_facilitys"
      }
    },
    {
      path: "/event/:event/facility/card/:id",
      name: "event_facilitys_card",
      component: FacilityProfile,
      beforeEnter: requireAuth,
      props: {
        page: "event_facilitys_card"
      }
    },
    {
      path: "/event/:event/facility/edit/:id",
      name: "event_facilitys_edit",
      component: FacilityForm,
      beforeEnter: requireAuth,
      props: {
        page: "event_facilitys_edit",
        action: "edit"
      }
    },
    {
      path: "/event/:event/facility/add",
      name: "event_facilitys_add",
      component: FacilityForm,
      beforeEnter: requireAuth,
      props: {
        page: "event_facilitys_add",
        action: "add"
      }
    },
    {
      path: "/travel",
      name: "travels",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "travels"
      }
    },
    {
      path: "/travel/card/:id",
      name: "travels_card",
      component: TravelProfile,
      beforeEnter: requireAuth,
      props: {
        page: "travels_card"
      }
    },
    {
      path: "/travel/edit/:id",
      name: "travels_edit",
      component: TravelForm,
      beforeEnter: requireAuth,
      props: {
        page: "travels_edit",
        action: "edit"
      }
    },
    {
      path: "/travel/add",
      name: "travels_add",
      component: TravelForm,
      beforeEnter: requireAuth,
      props: {
        page: "travels_add",
        action: "add"
      }
    },
    {
      path: "/event/:event/travel",
      name: "event_travels",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_travels"
      }
    },
    {
      path: "/event/:event/travel/add",
      name: "event_travels_add",
      component: TravelForm,
      beforeEnter: requireAuth,
      props: {
        page: "event_travels_add",
        action: "add"
      }
    },
    {
      path: "/event/:event/travel/edit/:id",
      name: "event_travels_edit",
      component: TravelForm,
      beforeEnter: requireAuth,
      props: {
        page: "event_travels_edit",
        action: "edit"
      }
    },
    {
      path: "/event/:event/travel/card/:id",
      name: "event_travels_card",
      component: TravelProfile,
      beforeEnter: requireAuth,
      props: {
        page: "event_travels_card"
      }
    },
    {
      path: "/event/:event/competition",
      name: "event_competition",
      component: Competition,
      beforeEnter: requireAuth,
      props: {
        page: "event_competition"
      }
    },
    {
      path: "/event/:event/competition/groups",
      name: "event_competition_groups",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_competition_groups"
      }
    },
    {
      path: "/event/:event/competition/matchs",
      name: "event_competition_calendar",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_competition_calendar"
      }
    },
    {
      path: "/event/:event/competition/matchs/:category_id/:phase_id",
      name: "event_competition_matchs",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_competition_matchs"
      }
    },
    {
      path: "/event/:event/competition/matchs/:category_id/:phase_id/:id/edit",
      name: "event_competition_matchs_edit",
      component: MatchForm,
      beforeEnter: requireAuth,
      props: {
        page: "event_competition_matchs_edit"
      }
    },
    {
      path: "/event/:event/competition/matchs/:id",
      name: "event_competition_matchs_card",
      redirect: "/event/:event/competition/matchs/:id/edit"
    },
    {
      path: "/event/:event/competition/scoreboard",
      name: "event_competition_scoreboard",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_competition_scoreboard"
      }
    },
    {
      path: "/event/:event/competition/scoreboard/:phase_id",
      name: "event_competition_scoreboard_phase",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_competition_scoreboard_phase"
      }
    },
    {
      path: "/event/:event/competition/stats",
      name: "event_competition_stats",
      component: CompetitionStats,
      beforeEnter: requireAuth,
      props: {
        page: "event_competition_stats"
      }
    },
    {
      path: "/event/:event/competition/stats/top_scores",
      name: "event_competition_stats_top_scores",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_competition_stats_top_scores"
      }
    },
    {
      path: "/event/:event/competition/stats/team_scores",
      name: "event_competition_stats_team_scores",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_competition_stats_team_scores"
      }
    },
    {
      path: "/event/:event/competition/stats/top_goalkeepers",
      name: "event_competition_stats_top_goalkeepers",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_competition_stats_top_goalkeepers"
      }
    },
    {
      path: "/event/:event/competition/sanctions",
      name: "event_competition_sanctions",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_competition_sanctions"
      }
    },
    {
      path: "/event/:event/competition/sanctions/:id",
      name: "event_competition_sanctions_edit",
      component: SanctionsForm,
      beforeEnter: requireAuth,
      props: {
        page: "event_competition_sanctions_edit"
      }
    },
    {
      path: "/event/:event/competition/injuries",
      name: "event_competition_injuries",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_competition_injuries"
      }
    },
    {
      path: "/event/:event/confirmations",
      name: "event_confirmations",
      component: ListView,
      beforeEnter: requireAuth,
      props: {
        page: "event_confirmations"
      }
    },
  ]
});

/**
 * Usuarios 10XX: solo home, listado /event y rutas bajo /event/:event/...
 */
function restrictedGestorPathAllowed(to) {
  if (!to || !to.path) {
    return true;
  }
  if (to.path === "/") {
    return true;
  }
  if (to.path === "/event") {
    return true;
  }
  if (to.path.indexOf("/event/") === 0) {
    return true;
  }
  return false;
}

/*
    This will check to see if the user is authenticated or not.
*/
function requireAuth(to, from, next) {
  //console.log( to );
  // console.log( from );
  // console.log( next );
  // console.log( "requireAuth User state: " + store.getters['user/getUserLoadStatus']() );
  // console.log( store );
  /*
      Determines where we should send the user.
    */
  function proceed() {
    /*
          If the user has been loaded determine where we should
          send the user.
        */
    if (store.getters["user/getUserLoadStatus"]() == 2) {
      /*
              If the user is not empty, that means there's a user
              authenticated we allow them to continue. Otherwise, we
              send the user back to the home page.
            */
      var oSession = store.getters["user/getSession"];
      //console.log( oSession );
      localStorage.setItem("redirect", to.path);
      if (moment(oSession.exp * 1000).valueOf() > moment().valueOf()) {
        var u = store.getters["user/getUser"];
        if (
          u &&
          isRestrictedEventTypeUserType(u.type) &&
          !restrictedGestorPathAllowed(to)
        ) {
          next({ name: "home" });
          return;
        }
        i18n.loadLanguageAsync("ca").then(function() {
          // store.commit( 'setPage', to.name );
          //console.log( )
          store.dispatch("setPage", to).then(function() {
            next();
          });
        });
      } else {
        store.dispatch("logout").then(function() {
          next({ name: "login" });
        });
      }
    }
  }

  /*
      Confirms the user has been loaded
    */
  if (store.getters["user/getUserLoadStatus"]() != 2) {
    /*
          If not, load the user
        */
    store.dispatch("loadUser").then(function() {
      //console.log( "WATCH: " + store.getters['user/getUserLoadStatus']() );
      if (store.getters["user/getUserLoadStatus"]() == 2) {
        // store.dispatch( 'loadTablesRelationship' ).then( function(){
        proceed();
        // });
      } else {
        store.dispatch("logout").then(function() {
          next({ name: "login" });
        });
      }
    });
  } else {
    /*
          User call completed, so we proceed
        */
    proceed();
  }
}

/**
 * Sesión válida y usuario type 1 (administrador BackOffice) para gestión de gestores.
 */
function requireBackofficeUserAdmin(to, from, next) {
  function proceed() {
    if (store.getters["user/getUserLoadStatus"]() == 2) {
      var oSession = store.getters["user/getSession"];
      localStorage.setItem("redirect", to.path);
      if (moment(oSession.exp * 1000).valueOf() > moment().valueOf()) {
        var u = store.getters["user/getUser"];
        if (!u || parseInt(u.type, 10) !== 1) {
          next({ name: "home" });
          return;
        }
        i18n.loadLanguageAsync("ca").then(function() {
          store.dispatch("setPage", to).then(function() {
            next();
          });
        });
      } else {
        store.dispatch("logout").then(function() {
          next({ name: "login" });
        });
      }
    }
  }

  if (store.getters["user/getUserLoadStatus"]() != 2) {
    store.dispatch("loadUser").then(function() {
      if (store.getters["user/getUserLoadStatus"]() == 2) {
        proceed();
      } else {
        store.dispatch("logout").then(function() {
          next({ name: "login" });
        });
      }
    });
  } else {
    proceed();
  }
}
